module.exports = __webpack_public_path__ + "static/media/logo.2ec9807a.png";